import { CourseSessionsResponse, courseSessionsApi } from "api/courseSessionsApi";
import { useCallback, useEffect, useState } from "react";

export const useCourseSessions = (courseId?: string | number) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<CourseSessionsResponse>({ data: [], isReady: false });

  const fetchCourseSessions = useCallback(async (courseId?: string | number) => {
    const res = await courseSessionsApi.fetchByCourseId(Number(courseId));
    try {
      if (!courseId) {
        setLoading(false);
        return;
      }
      setData(res.data);
    } catch (error) {
      // Handle error appropriately, perhaps with another state variable
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCourseSessions(courseId);
  }, [courseId]);

  return { loading, data: data.data, isReady: data.isReady, refresh: () => fetchCourseSessions(courseId) };
};
